import { render, staticRenderFns } from "./MessageAllPOS.vue?vue&type=template&id=69d9e21c&lang=pug"
import script from "./MessageAllPOS.vue?vue&type=script&lang=js"
export * from "./MessageAllPOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports